import { Ionicons } from "@expo/vector-icons";
import { Text, View } from "react-native";
import { useCSSVariable } from "uniwind";

export function MaintenanceScreen() {
  const [brandColor] = useCSSVariable(["--color-brand"]) as [string];

  return (
    <View className="bg-background flex-1 items-center justify-center p-6">
      <Ionicons name="construct-outline" size={64} color={brandColor} />

      <Text className="font-display text-foreground mt-6 text-center text-2xl font-semibold">
        Em manutenção
      </Text>

      <Text className="text-muted-foreground mt-3 text-center text-base">
        Estamos realizando melhorias e voltamos em breve!
      </Text>
    </View>
  );
}
